export default {
  myBets: [],
  bets: [],
  topWins: [],
  isProcess: false,
}